import React, { useCallback, useState } from 'react';
import { Query } from '../_common';
import SearchBar from '../SearchBar';
import { SearchTypeEnum } from '../../types/SearchTypeEnum';
import { ModalForm, Option } from './interface';
import { GET_ALL_CREW_FILTERED, GET_ALL_CUSTOMERS } from '../../graphql/client/queries';
import {
    GetAllCustomers,
    GetAllCustomers_getAllCustomers as Customer,
    GetAllCrewFiltered_getAllCrewFiltered as Crew,
    GetAllCrewFiltered,
} from '../../types/schemaTypes';
import CrewList from './CrewList';
import { Error, Loading } from '../_common';
import AddCrewModal from './AddEditCrewModal/AddEditCrewModal';
import './Crews.scss';
import { useQuery } from '@apollo/client/react';
import { useStoreContext } from '../App/StoreProvider';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';
import { useMutation } from '@apollo/client/react';
import { SAVE_CREW, DELETE_CREW } from '../../graphql/client/mutations';
import { SaveCrew } from '../../types/schemaTypes';
import { Alert } from 'react-bootstrap';


import {  ToastContainer, toast } from 'react-toastify';
import {toastOpt} from '../../utils/helpers/toastHelper'

const toasterOptions = { duration: 2500 };
const Messages = {
    delete: 'Crew deleted successfully',
};
const ErrorMessages = {
    delete: 'Failed to delete Crew',
};

let selectedCrew: Crew | undefined;

const PAGE_SIZE = 50;

const Crews = (): React.ReactElement => {
    const [showAddCrewModal, setShowAddCrewModal] = useState(false);
    const [modalForm, setModalForm] = useState(ModalForm.EMPTY);
    const [isEndOfResults, setIsEndOfResults] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = 'SBS';
    const canEditCrew = useAuthContext().userHasPermission(PermissionEnum.EditCrew);
    

    const [state] = useStoreContext();
    const {
        crewList: { searchPhrase },
    } = state;

    const variables = {
        input: searchPhrase,
    };

    const onCompletedSaveCrew = (data: SaveCrew): void => {
        if (data.saveCrew === null) return;
        const saveCrewErrors = data.saveCrew.errors;
        if (saveCrewErrors && saveCrewErrors.length > 0) {
            setErrorMessage(saveCrewErrors[0] || '');
        } else {
            selectedCrew = undefined;
            setShowAddCrewModal(false);
        }
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };

        Comp.displayName = 'toast';
        return Comp;
    };
    const onCompleted = action => {
      
       toast.success(Messages[action],toastOpt);
        //refetch();
    };

    const onActionError = action => {
     
        toast.error(ErrorMessages[action],toastOpt);
        //refetch();
    };

    const [deleteCrew] = useMutation(DELETE_CREW, {
        onCompleted: () => onCompleted('delete'),
        onError: () => onActionError('delete'),
        refetchQueries: () => {
            return [
                {
                    query: GET_ALL_CREW_FILTERED,
                    variables: { variables },
                },
            ];
        },
    });

    const [saveCrew] = useMutation<SaveCrew>(SAVE_CREW, {
        onCompleted: onCompletedSaveCrew,
        refetchQueries: () => {
            return [
                {
                    query: GET_ALL_CREW_FILTERED,
                    variables: { variables },
                },
            ];
        },
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onDelete = useCallback(async (record: any) => {
        const variables = { input: { crewId: record.id } };
        await deleteCrew({ variables });
    }, []);

    const handleOnHide = (): void => {
        selectedCrew = undefined;
        setErrorMessage('');
        setShowAddCrewModal(false);
    };
    const handleOnSave = async (id: number, crewNumber: string, customerId: number): Promise<void> => {
        if (selectedCrew) {
            const selectedCrewMirron = {...selectedCrew}
            selectedCrewMirron.crewNumber = crewNumber;
            selectedCrewMirron.customerId = customerId;
            selectedCrew = {...selectedCrewMirron}
        }

        const variables = { input: { id, crewNumber, customerId } };
        await saveCrew({ variables });
    };
    const { data: customersData } = useQuery<GetAllCustomers>(GET_ALL_CUSTOMERS);
    const options: Option[] = [];

    if (customersData && customersData.getAllCustomers) {
        customersData.getAllCustomers.forEach((element: Customer | null) => {
            if (!element || element.id === null) return;
            const id = element.id;
            const displayName = element && element.customerName ? element.customerName : '<None>';
            options.push({
                id: id,
                name: displayName,
            });
        });
    }
    document.title = 'Crews';
    
    return (
        <Query<GetAllCrewFiltered> query={GET_ALL_CREW_FILTERED} variables={variables}>
            {({
                error,
                data,
                loading,
                refetch,
                fetchMore,
            }): React.ReactElement | null => {

                const offset = data && data.getAllCrewFiltered ? data.getAllCrewFiltered.length / PAGE_SIZE : 0;
                React.useEffect(() => {

                    if (
                        offset % 1 !== 0 ||
                        (!isEndOfResults && data && data.getAllCrewFiltered && data.getAllCrewFiltered.length < PAGE_SIZE)
                    ) {
                        // If offset is not a whole number, the end of the results has been reached. (8/22/19) - BS
                        setIsEndOfResults(true);
                    }
                }, [data, data?.getAllCrewFiltered?.length]);

                if (loading) {
                    return <Loading />;
                }

                if (error) {
                    return <Error error={error} />;
                }

                const crews: Crew[] = [];

                if (data && data.getAllCrewFiltered && data.getAllCrewFiltered.length !== 0) {
                    data.getAllCrewFiltered.forEach((element) => {
                        if (element !== null) {
                            crews.push(element as Crew);
                        }
                    });
                }

                return (
                    <div className="Crews-Container">
                        <ToastContainer />
                        <div className="Crews-Top-Container">
                            <div className="Crews-SearchBar">
                                <SearchBar type={SearchTypeEnum.Crew}></SearchBar>
                            </div>
                            <div className="Crews-RightOptions">
                                {canEditCrew && (
                                    <div
                                        className="Crews-Create-New-Crew Row"
                                        onClick={() => {
                                            setShowAddCrewModal(true);
                                            setModalForm(ModalForm.ADD_CREW);
                                        }}
                                    >
                                        <i className="material-icons Crews-Icon">add_circle</i>
                                        <span className="Crews-Link">Create New Crew</span>
                                    </div>
                                )}
                            </div>
                            <div className="Crews-Errors">{errorMessage}</div>
                        </div>
                        <div className="Crews-Bottom-Container">
                            <div className="Crews-Header-Title">Crew</div>
                            <div className="Crews-Header-Title">Customer</div>
                            <div className="Crews-Header-Title">Action</div>
                        </div>
                        {crews.length > 0 && (
                            <CrewList
                                crews={crews}
                                refetch={refetch}
                                isLoading={loading}
                                canEditCrews={canEditCrew}
                                isEndOfResults={isEndOfResults}
                                onEditClick={Crew => {
                                    setShowAddCrewModal(true);
                                    setModalForm(ModalForm.EDIT_CREW);
                                    selectedCrew = Crew;
                                }}
                                onDelete={onDelete}
                                onLoadMore={() =>
                                    fetchMore({
                                        variables: {
                                            offset,
                                        },
                                        updateQuery: (prev, { fetchMoreResult }) => {
                                            if (
                                                prev &&
                                                fetchMoreResult &&
                                                prev.getAllCrewFiltered &&
                                                fetchMoreResult.getAllCrewFiltered
                                            ) {
                                                return Object.assign({}, prev, {
                                                    getAllCrewFiltered: [
                                                        ...prev.getAllCrewFiltered,
                                                        ...fetchMoreResult.getAllCrewFiltered,
                                                    ],
                                                });
                                            } else {
                                                return prev;
                                            }
                                        },
                                    })
                                }
                            />
                        )}
                        <AddCrewModal
                            show={showAddCrewModal}
                            modalForm={modalForm}
                            options={options}
                            selectedCrew={selectedCrew}
                            onClickHide={handleOnHide}
                            onClickSave={handleOnSave}
                            errorMessage={errorMessage}
                        ></AddCrewModal>
                    </div>
                );
            }}
        </Query>
    );
};

export default Crews;

